import React from 'react'
import '../ContactContent'
import ContactContent from '../ContactContent'

function Contact() {
  return (
    <>
        <ContactContent/>
    </>
  )
}

export default Contact